import React, { useState } from 'react'
import style from './CreateZone.module.css'
import zoneImg from '../../../../assets/img/zonesMargin.png';
import InputSearch from '../../../../utils/components/InputSearch/InputSearch';
import Button from '../../../../utils/components/Button/Button';
import InputTextArea from '../../../../utils/components/InputTextArea/InputTextArea';
export const CreateZone = ({ formik, adminName,
    setAdminName,
    adminType, usersToAdminZone,
    setAdminType, categories }) => {
    const [imgSrc, setImgSrc] = useState(null)
    const [isShowCategories, setIsShowCategories] = useState(false)
    const [categoryName, setCategoryName] = useState("")
    const [adminChosen, setAdminChosen] = useState(null)

    return (
        <div>
            <label className={style.zone_img_container}>
                <input type='file' onChange={(e) => {
                    if (e.target.files[0] && e.target.files[0].type.includes('image')) {
                        setImgSrc(URL.createObjectURL(e.target.files[0]))
                        formik.setFieldValue("picture", e.target.files[0])
                    }
                    //  var filesTarget = e.target.files[0]
                    // filesTarget.url = URL.createObjectURL(e.target.files[0])
                    //setDataFile(filesTarget)
                }} />
                <img
                    alt="img"
                    className={`profile-picture-img`}
                    onError={(e) => (e.target.src = zoneImg)}
                    src={imgSrc ? imgSrc : zoneImg}
                    accept="image/*"
                />
            </label>
            <div className={style.zone_input_name_container}>
                <div>
                    <input className={style.zone_input} type="text" placeholder='nombre' value={formik.values.name} name='name' onChange={formik.handleChange} />
                </div>
            </div>
            <div className={style.zone_input_admin_category}>
                <div className={style.zone_input_container}>
                    <div>
                        {adminChosen ? adminChosen : 'Selecione el administrador de la zona'}

                        <div className={style.zone_input_admin_container}>
                            <select className={style.zone_input} value={adminType} onChange={e => setAdminType(e.target.value)} >
                                <option value={""}>Selecciona tipo de usuario</option>
                                <option value="franchise">EcoTienda</option>
                                <option value="representative">EcoMaster</option>
                                <option value="warehouse">EcoCeo</option>

                            </select>

                            <InputSearch searchData={v => setAdminName(v)} renderData={usersToAdminZone.map(user => {
                                let name = ""
                                let lastName = ""
                                switch (adminType) {
                                    case "franchise":
                                        name = user.socialReason
                                        break;
                                    case "representative":
                                        name = user.name
                                        break;
                                    case "warehouse":
                                        name = user.name
                                        break;
                                }
                                const fullName = `${name} ${lastName}`.trim()
                                return (
                                    <div onClick={() => {


                                        formik.setFieldValue('adminEntityId', user._id)
                                        setAdminChosen(fullName)
                                    }}>{fullName}</div>
                                )
                            })} />
                        </div>
                    </div>

                </div>
                <div className={style.zone_input_container}>
                    <div>selecciona la categoría</div>

                    <div className={style.zone_input_category_container} >
                        <input readOnly className={style.zone_input} type="text" placeholder='categoría' value={categoryName} onClick={() => setIsShowCategories(true)} />
                        {
                            isShowCategories && (
                                <div className={style.zone_input_select_container}>
                                    {categories.map(category => (
                                        <div key={category._id} onClick={() => {
                                            //   formik.set
                                            formik.setFieldValue('categoryId', category._id)
                                            setCategoryName(category.name)
                                            setIsShowCategories(false)
                                        }} >{category.name}</div>
                                    ))}
                                </div>
                            )
                        }

                    </div>
                    <div>

                        <InputTextArea placeholder={"Introduzca la descripción"} name='description' setValue={(value) => { formik.setFieldValue('description', value) }} value={formik.values.description} />
                    </div>
                </div>
            </div>
            <div className={style.zone_btn}>
                <Button text='Guardar' onClick={formik.handleSubmit} />
            </div>
        </div>
    )
}
